import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PageDesignFilledStandard.js";
import d from "../components/PfIcon.js";
const e = (r, t) => {
  const a = {
    ...r,
    ...t.attrs
  };
  return i(d, n(a, {
    icon: o
  }), null);
};
e.displayName = "PageDesignFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
